import { demoFile, componentWithVariants, variant } from 'system/demo';
import { TopicStructure } from 'structure/topic';
import { TopicScreen } from 'structure/topic';
import { defaultPersonaList } from 'util/testpersonas';


demoFile('structure/topic');

const comments = [
    { key: 3, from: 'c', text: 'Why is Mothra the best?' },
    { key: 4, from: 'd', text: 'Why is Mechagodzilla the best?' },
    { key: 5, from: 'bb', text: 'Why is King Gidorah the best?' },
    { key: 6, from: 'f', text: 'Why is Rodan the worst?' },
    { key: 1, from: 'aa', text: 'Who is Godzilla?' },
    { key: 10, from: 'g', replyTo: 1, text: 'He is a very large lizard' },
    { key: 2, from: 'b', text: 'Why are Godzilla and Kong fightning?' },
    { key: 20, from: 'h', replyTo: 2, text: 'Because it is cool' },
    { key: 21, from: 'i', replyTo: 2, text: 'They are mortal enemies' },
    { key: 22, from: 'b', replyTo: 21, text: 'That is not true, they do not fight' },
];

const topicPoll = [
    { key: 1, from: 'c', value: { label: 'Neutre' } },
    { key: 2, from: 'c', value: { label: 'Neutre' } },
    { key: 3, from: 'c', value: { label: 'N\xE9gatif' } },
    { key: 4, from: 'c', value: { label: 'N\xE9gatif' } },
    { key: 5, from: 'c', value: { label: 'N\xE9gatif' } },
    { key: 6, from: 'c', value: { label: 'N\xE9gatif' } },
    { key: 7, from: 'c', value: { label: 'Tr\xE8s n\xE9gatif' } },
    { key: 8, from: 'c', value: { label: 'Tr\xE8s n\xE9gatif' } },
    { key: 9, from: 'c', value: { label: 'Tr\xE8s n\xE9gatif' } },
    { key: 10, from: 'c', value: { label: 'Tr\xE8s n\xE9gatif' } },
    { key: 11, from: 'c', value: { label: 'Tr\xE8s n\xE9gatif' } },
    { key: 12, from: 'c', value: { label: 'Tr\xE8s n\xE9gatif' } },
    { key: 13, from: 'c', value: { label: 'Tr\xE8s n\xE9gatif' } },
];

const relatedConversations_derived = [
    { key: 'le-temps-dcran' },
    { key: 'le-vieillissement-de-la-population' },
    { key: 'le-vieillissement-de-la-population-2' },
];

const relatedConversations = [
    { deleted: false, from: 'a', id: 'le-temps-dcran', key: 'le-temps-dcran', text: "Le temps d'\xE9cran", time: 1733775285001 },
    { deleted: false, from: 'b', id: 'le-vieillissement-de-la-population', key: 'le-vieillissement-de-la-population', text: 'Le vieillissement de la population', time: 1733775279409 },
    { deleted: false, from: 'b', id: 'le-vieillissement-de-la-population-2', key: 'le-vieillissement-de-la-population-2', text: 'Le vieillissement de la population, suivi', time: 1733775279409 },
];

const relatedArticles = [
    { text: 'Le recours \xE0 l\u2019IA en hausse dans la population canadienne', picture: 'https://images.radio-canada.ca/q_auto,w_1200/v1/ici-premiere/16x9/mdr-robot-conversationnel.jpg', type: 'text', url: 'https://ici.radio-canada.ca/nouvelle/2048276/ia-canada-sondage-hausse-utilisation', id: 1 },
    { text: 'Google et la gestion de la circulation : la Ville esp\xE8re des \xE9conomies', picture: 'https://images.radio-canada.ca/q_auto,w_1200/v1/ici-info/16x9/gestionnaire-arteriel.jpg', type: 'text', url: 'https://ici.radio-canada.ca/nouvelle/2046551/intelligence-artificielle-circulation-automobile-gestion-arterielle', id: 2 },
    { text: 'Des artistes poursuivent OpenAI, accus\xE9e d\u2019avoir utilis\xE9 leurs livres pour ChatGPT', picture: 'https://images.radio-canada.ca/q_auto,w_1200/v1/ici-info/16x9/ai-intelligence-artificielle-chatgpt.jpg', type: 'text', url: 'https://ici.radio-canada.ca/nouvelle/1995206/livres-chatgpt-openai-poursuite', id: 3 },
    { text: 'Pr\xE9dire les complications du cancer gr\xE2ces \xE0 L\u2019IA', picture: 'https://images.radio-canada.ca/v1/ici-tele/16x9/decouverte-sante-ia-intelligence-artificielle-4-fevrier-2024.jpg', type: 'media', url: 'https://ici.radio-canada.ca/info/videos/1-8887402/predire-complications-cancer-graces-a-ia', id: 4 }
];

const globals = {
    name: 'L\u2019intelligence artificielle et son incidence sur nos vies',
    status: 'live',
    startAt: '2024-06-01',
    endAt: '2025-06-30',
    conversationStarter: 'Des questions? Des craintes? Parlez d\u2019IA avec nos sp\xE9cialistes.',
    poll: {
        question: 'Comment voyez-vous la place grandissante que prend l\u2019IA dans votre quotidien?',
        type: 'MultipleChoice',
        showDataviz: true,
        options: [
            { label: 'Tr\xE8s positif' },
            { label: 'Positif' },
            { label: 'Neutre' },
            { label: 'N\xE9gatif' },
            { label: 'Tr\xE8s n\xE9gatif' }
        ]
    },
    relatedArticles: [
        { text: 'Le recours \xE0 l\u2019IA en hausse dans la population canadienne', picture: 'https://images.radio-canada.ca/q_auto,w_1200/v1/ici-premiere/16x9/mdr-robot-conversationnel.jpg', type: 'text', url: 'https://ici.radio-canada.ca/nouvelle/2048276/ia-canada-sondage-hausse-utilisation', id: 1 },
        { text: 'Google et la gestion de la circulation : la Ville esp\xE8re des \xE9conomies', picture: 'https://images.radio-canada.ca/q_auto,w_1200/v1/ici-info/16x9/gestionnaire-arteriel.jpg', type: 'text', url: 'https://ici.radio-canada.ca/nouvelle/2046551/intelligence-artificielle-circulation-automobile-gestion-arterielle', id: 2 },
        { text: 'Des artistes poursuivent OpenAI, accus\xE9e d\u2019avoir utilis\xE9 leurs livres pour ChatGPT', picture: 'https://images.radio-canada.ca/q_auto,w_1200/v1/ici-info/16x9/ai-intelligence-artificielle-chatgpt.jpg', type: 'text', url: 'https://ici.radio-canada.ca/nouvelle/1995206/livres-chatgpt-openai-poursuite', id: 3 },
        { text: 'Pr\xE9dire les complications du cancer gr\xE2ces \xE0 L\u2019IA', picture: 'https://images.radio-canada.ca/v1/ici-tele/16x9/decouverte-sante-ia-intelligence-artificielle-4-fevrier-2024.jpg', type: 'media', url: 'https://ici.radio-canada.ca/info/videos/1-8887402/predire-complications-cancer-graces-a-ia', id: 4 },
    ],
    testContents: [
        { id: '3ldrP0ctarks-test', text: "Pr\xE9dire les complications du cancer gr\xE2ce \xE0 l'IA", picture: 'https://placehold.co/250x150', type: 'media' }
    ],
    nextTopicPoll: {
        question: 'De quoi aimeriez-vous qu\u2019on discute bient\xF4t?',
        type: 'MultipleChoiceOther',
        showDataviz: false,
        otherOptionValue: 'Autre',
        otherOptionPlaceholder: 'R\xE9diger un sujet...',
        options: [
            { label: 'Guerre en Ukraine' },
            { label: '\xC9lections am\xE9ricaines' },
            { label: "Inflation et pouvoir d'achat" }
        ]
    },
    titledWriter: {
        iconeUrl: 'https://images.radio-canada.ca/q_auto,w_1200/v1/ici-info/perso/logo-radio-canada-pizza-rouge-archives.jpg'
    }
};

const personas = [
    ...defaultPersonaList,
    { key: 'aa', name: 'John Doe', hue: 250, isAffiliatedToPSM: true, title: 'Comedian' },
    { key: 'bb', name: 'Jane Doe', hue: 250, isAffiliatedToPSM: true, title: 'Journalist' }
];

const baseCollections = {
    comment: comments,
    topicPoll,
    relatedArticles,
    relatedConversations,
    derived_relatedQuestionPreview: relatedConversations_derived,
    persona: personas
};

const amaTopicFeatures = {
    amaheader: true,
    amapoll: true,
    askmeanything: true,
    commentssort: true,
    context_entry_point: true,
    editorialtopic: true,
    hide_rejected: true,
    jigsawmoderation: true,
    moderationhelp: true,
    nexttopicpoll: true,
    pin_answer: true,
    poll: true,
    premoderation: false,
    premoderator: false,
    record_entry_url: true,
    report_comment: true,
    titledWriter: true,
    tomheader: true,
    topicbottompoll: false,
    topicfollow: true,
    topicincontentpoll: true,
    topiclivestatus: true,
    topicofthemomentconfig: false,
    topicparticipants: true,
    topicphototeaser_topic: true,
    topicpoll: true,
    topicpopularquestions: true,
    editorialReadinglist: true,
    topicrelatedcontent: true,
    topicrelatedconversations: true,
    topictoppoll: false,
    topictype: true,
    topicuserctaquestions: true,
    topicuserquestions: true,
    undefined: false,
    upvote: true
};

const standardTopicFeatures = {
    aimoderation: true,
    amaheader: true,
    amapoll: true,
    askmeanything: false,
    commentssort: true,
    context_entry_points: true,
    editorialtopic: true,
    hide_rejected: true,
    jigsawmoderation: true,
    moderationhelp: true,
    nexttopicpoll: true,
    pin_answer: true,
    poll: true,
    premoderation: false,
    premoderator: false,
    record_entry_url: true,
    report_comment: true,
    titledWriter: true,
    tomheader: true,
    topicbottompoll: false,
    topicfollow: true,
    topicincontentpoll: false,
    topiclivestatus: true,
    topicofthemomentconfig: true,
    topicparticipants: true,
    topicphototeaser_topic: true,
    topicpoll: true,
    topicpopularquestions: true,
    editorialReadinglist: true,
    topicrelatedcontent: true,
    topicrelatedconversations: true,
    topictoppoll: true,
    topictype: true,
    topicuserctaquestions: true,
    topicuserquestions: true,
    undefined: false,
    upvote: true
};

componentWithVariants('TopicScreen', TopicScreen, {}, [
    variant('Ask Me Anything', { state: { globals, collections: baseCollections, modulePublic: { language: 'french_canadian' }, roles: ['Editorial'] }, features: Object.keys(amaTopicFeatures), structureKey: 'topic' }),
    variant('Standard', { state: { globals, collections: baseCollections, modulePublic: { language: 'french_canadian' }, roles: ['Editorial'] }, features: Object.keys(standardTopicFeatures), structureKey: 'topic' })
]);
